import TerminalNew from './TerminalNew'

export default TerminalNew;